import React from 'react';

const MultiCitySegments = ({ segments, activeSegmentIndex, selectedFlights, onSegmentClick, enrichedSegments }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${weekday} ${day} ${month} ${year}`;
  };

  const handleSegmentClick = (index) => {
    onSegmentClick(index);
  };

  if (!segments || segments.length === 0) return null;

  return (
    <div className="flex gap-4 mb-6">
      {segments.map((segment, index) => {
        const isActive = index === activeSegmentIndex;
        const isSelected = selectedFlights[index] !== undefined;
        const enriched = enrichedSegments[index];

        const fromDisplay = enriched ? `${enriched.fromAirport.iata}` : segment.from;
        const toDisplay = enriched ? `${enriched.toAirport.iata}` : segment.to;

        return (
          <div key={index} className="flex-1">
            <button
              onClick={() => handleSegmentClick(index)}
              className={`w-full rounded-lg py-2.5 px-4 text-center transition-all ${isActive
                  ? 'bg-jet-yellow'
                  : 'bg-jet-gray-200 hover:bg-jet-gray-300 cursor-pointer'
                }`}
            >
              <div className="text-[0.9rem] font-semibold text-jet-gray-900 mb-0.5 leading-tight">
                {fromDisplay} → {toDisplay}
              </div>
              <div className="text-[0.8rem] text-jet-gray-700 font-semibold leading-tight">
                {formatDate(segment.date)}
              </div>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default MultiCitySegments;
